export default "__VITE_ASSET__CxBG26qA__"